/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import axios from 'axios';
import { constants } from 'utils';
import { put } from 'redux-saga/effects';
import { logout } from 'containers/Login/duck/actions';
import StorageFactory from './storageFactory';
import { attachSigning } from './signing';
import { callerUrl } from './signing/prepare';

const storage = StorageFactory.getStorage();
const token = storage.getItem('access_token');
const instance = axios.create({
  baseURL: constants.API,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
});

// Gắn ký TRƯỚC response interceptor refresh bên dưới: 401 do side-server chặn
// chữ ký phải được đánh dấu isSignatureReject trước khi tới luồng refresh.
attachSigning(instance);

// Add a response interceptor

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // 401 chữ ký không phải hết phiên: không refresh, không xoá token, không logout.
    if (error.isSignatureReject) {
      return Promise.reject(error);
    }
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = storage.getItem('refresh_token');
      const bgOverflow = document.getElementById('bgOverflow');
      if (bgOverflow) {
        bgOverflow.style.display = 'flex';
        if (document.getElementById('loading')) {
          document.getElementById('loading').style.opacity = '0';
        }
      }
      return (
        axios
          .post(`${constants.API}/auth/login/refresh`, {
            refresh_token: `${refreshToken}`
          })
          // eslint-disable-next-line consistent-return
          .then(res => {
            if (res.status === 200) {
              storage.setItem('access_token', res.data.data.access_token);
              storage.setItem('refresh_token', res.data.data.refresh_token);
              axios.defaults.headers.Authorization = `Bearer ${res.data.data.access_token}`;
              originalRequest.headers.Authorization = `Bearer ${res.data.data.access_token}`;
              if (bgOverflow) {
                bgOverflow.style.display = 'none';
              }
              return axios.request(originalRequest);
            }
          })
          // eslint-disable-next-line consistent-return
          .catch(err => {
            if (bgOverflow) {
              bgOverflow.style.display = 'none';
            }
            // Refresh bị side-server chặn chữ ký không phải refresh token hết hạn:
            // không xoá token, không logout.
            if (err.isSignatureReject) {
              return Promise.reject(err);
            }
            if (err.response.status === 401) {
              put(logout());
              // Ký làm config.url thành tuyệt đối cho mọi caller; trước đó caller truyền url
              // tương đối (vd. /auth/login) thì replace này là no-op. Chỉ thêm /pure-route khi
              // url gốc của caller thật sự chứa constants.API, giữ đúng hành vi cũ.
              if (callerUrl(originalRequest).includes(constants.API)) {
                originalRequest.url = originalRequest.url.replace(
                  constants.API,
                  `${constants.API}/pure-route`
                );
              }
              delete originalRequest.headers.Authorization;
              storage.removeItem('access_token');
              storage.removeItem('refresh_token');
              if (document.getElementById('logout')) {
                document.getElementById('logout').click();
              }
              return axios.request(originalRequest);
            }
          })
      );
    }
    return Promise.reject(error);
  }
);
export default instance;
